import { Directive, HostBinding } from "@angular/core";

// Increments for each instance of this component
let nextId = 0;

@Directive({
  selector: "bit-hint",
  host: {
    // class: "tw-text-muted tw-inline-block tw-mt-1",
    class: "tw-text-sm tw-font-normal tw-opacity-80 tw-mt-1 tw-inline-block",
  },
})
export class BitHintComponent {
  @HostBinding() id = `bit-hint-${nextId++}`;
}
